const CircumstancesOfDeath = Object.freeze({
  NATURAL: 'nat',
  VIOLENTE: 'viol',
})

export default CircumstancesOfDeath
